import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import { React, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";
import { AuthProvider } from './context/AuthContext';
import { ToastContainer, toast } from 'react-toastify';

import AnonymousRoutes from './utils/AnonymousRoutes';
import PrivateRoutes from './utils/PrivateRoutes';
import Header from "./components/layouts/Header";
import Dashboard from './components/layouts/Dashboard';

import Login from './components/accounts/Login';
import AccountActivate from './components/accounts/AccountActivate';
import ForgotPassword from './components/accounts/ForgotPassword';
import ForgotPasswordConfirmation from './components/accounts/ForgotPasswordConfirmation';

import PatientList from './components/patients/PatientList';
import NewPatient from './components/patients/NewPatient';
import PatientVisitAnalytics from './components/patients/PatientAnalytics';
import DiagnosisDashboard from './components/patients/DiagnosisDashboard';
import PatientPrescription from './components/patients/prescription/PatientPrescription';

import PatientInvoices from './components/billing/PatientInvoices';

import AppointmentDetails from './components/appointments/AppointmentDetails';
import NewAppointment from './components/appointments/NewAppointment';

import CreateSMSCampaign from './components/communication/CreateSMSCampaign';
import SMSCampaign from './components/communication/SMSCampaign';
import CommunicationNotifications from './components/communication/CommunicationNotifications';

export default function App() {
	return (
		<Router>
			<AuthProvider>
				<Header applicationName="VisionThink Tech" />
				<Routes>
					<Route element={<PrivateRoutes />}>
						<Route path="/" element={<Dashboard />} />
						<Route path="/appointment" element={<AppointmentDetails />} />
						<Route path="/appointment/new" element={<NewAppointment />} />

						<Route path="/patient/:patient_id" element={<NewPatient />} />
						<Route path="/patient/new" element={<NewPatient />} />
						<Route path="/patient-management/patient" element={<PatientList />} />
						<Route path="/patient-management/patient-prescription" element={<PatientPrescription />} />

						<Route path="/billing/patient-invoices" element={<PatientInvoices />} />

						<Route path="/analytics-reports/patient-analytics" element={<PatientVisitAnalytics />} />
						<Route path="/analytics-reports/diagnosis-dashboard" element={<DiagnosisDashboard />} />

						<Route path="/communication/sms-campaign/list" element={<SMSCampaign />} />
						<Route path="/communication/sms-campaign/create" element={<CreateSMSCampaign />} />
						<Route path="/communication/communication-notifications" element={<CommunicationNotifications />} />
					</Route>

					<Route element={<AnonymousRoutes />}>
						<Route path="/user/account/activate" element={<AccountActivate />} />
						<Route path="/user/account/verify-email" element={<AccountActivate />} />
						<Route path="/user/reset-password" element={<ForgotPassword />} />
						<Route path="/user/reset-password-confirmation" element={<ForgotPasswordConfirmation />} />
						<Route path="/sign-in" element={<Login />} />
					</Route>
					<Route path="*" element={<NotFound />} />
				</Routes>
				<ToastContainer />
			</AuthProvider>
		</Router>
	)
}


function NotFound() {
	const navigate = useNavigate();

	useEffect(() => {
		localStorage.removeItem("AuthTokens");
		toast.error("Page not found!");
		navigate("/sign-in");
	}, [navigate]);

	return null;
}